// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_-WJ","cls2":"PaywallPage-cls2_PB4 PaywallPage-cls1_-WJ"};